import React, { useEffect, useState, useContext, useRef } from 'react';
import { getLogo }  from './LocalizedPictures'
import { setNewAnswer, calculateResult, clearAllAnswer,getAllAnswer } from '../Store'
import CountUp from 'react-countup';
import './QuestionStep/style/Result.css'
import './QuestionStep/style/landing.css'
import star from './QuestionStep/assets/star.png'
import cloud1 from './QuestionStep/assets/calculator.png'
import cloud2 from './QuestionStep/assets/cloud3.png'
import facebook from './QuestionStep/assets/facebook.png'
import linkdin from './QuestionStep/assets/linkdin.png'
import mail from './QuestionStep/assets/mail.png'
import twit from './QuestionStep/assets/twit.png'
import whatsapp from './QuestionStep/assets/whatsapp.png'
import gifRresult from './QuestionStep/assets/16_pencil 2.gif'
import jpgResult from './QuestionStep/assets/static/16_pencil-2.jpg'

import './Home.css'
import { useHistory } from 'react-router-dom'
import './Gif.css'
import { AppContext} from '../contexts/AppProvider'
import { useLocalize } from 'localize-react';


const Form = () => {
    const { translate } = useLocalize()
    const nameInput = useRef(null);
    const phoneInput = useRef(null);
    const emailInput = useRef(null);


    const { settings } = useContext(AppContext)
    const history = useHistory();

    const [state, setState] = React.useState({
        fullname: "",
        phone: "",
        email: "",
        approvehidden: true
    });

    const [errors, setErrors] = React.useState({
        fullName: "",
        phone: "",
        email: ""
    })

    function handleChange(evt) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value
        });
    }
    function handleCheckbox(evt) {
        setState({
            ...state,
            [evt.target.name]: !state.approvehidden
        });
    }
    console.log("calculateResult 2");
    let theNumber = calculateResult();
    let yearsNumber = theNumber * 12;
    
    function handleValidation(){ 
        let { fullname, phone, email } = state
        let isValidForm = true
        let registeredErrors = {}


     

        let emailPath = new RegExp(/[-a-zA-Z0-9@@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@@:%_\+.~#?&//=]*)/);
        if (!emailPath.test(email)) {
             isValidForm = false;
             registeredErrors["email"] = translate('Please enter a valid email');
            emailInput.current.focus();
        }

        if(!email.length) {
            isValidForm = false
            registeredErrors['email'] = translate('Email is required')
            emailInput.current.focus();

        }


        
        let phonePath = new RegExp(/([0-9]{8,})|(^[0]([0-9]{1,})\-+[0-9]{3}[0-9]{4,})/);
        if (!phonePath.test(phone)) {
            isValidForm = false
            registeredErrors['phone'] = translate('Number is not valid')
            phoneInput.current.focus();
        }

        if(!phone.length) {
            isValidForm = false
            registeredErrors['phone'] = translate('Number is required')
            phoneInput.current.focus();
        }

        if(!fullname.length) {
            isValidForm = false
            registeredErrors['fullname'] = translate('Full name is required')
            nameInput.current.focus();
        }



   
  
        
        setErrors(registeredErrors)
        return isValidForm
    }

    function formSubmitHandler(e) {
        e.preventDefault();
        
        if (handleValidation()) {
            activateSpinner();
            sendForm();
        } else {
            let errorsKeys = Object.keys(errors)
            console.log(errorsKeys)
        }
    }

    function activateSpinner() {
        document.querySelector('.btnForm').classList.add('locked');
    }

    const answers = getAllAnswer();

    function sendForm() {                                        

        var fdata = new FormData();

        //STATIC VERSION
        var firstName = state.fullname;
        var lastName= state.fullname;
        if (state.fullname != null && state.fullname.indexOf(" ")>-1) {
            firstName = state.fullname.split(' ')[0];
            lastName = state.fullname.split(' ')[1];
        }
        fdata.append("first_name", firstName);
        fdata.append("last_name", lastName);
        fdata.append('phone', state.phone);
        fdata.append('MailingList', state.approvehidden);
        fdata.append('event_type', "calc_waiting_list");
        fdata.append('registered_date', new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString());
        fdata.append('email', state.email);
        fdata.append('website_origin', "He");
        fdata.append('media_source', "calc_app");
        fdata.append("q1", answers["1"]);
        fdata.append("q2", answers["2"]);
        fdata.append("q3", answers["3"]);
        fdata.append("q4", answers["4"]);
        fdata.append("q5", answers["5"]);
        fdata.append("q6", answers["6"]);
        fdata.append("q7", answers["7"]);
        fdata.append("q8", answers["8"]);
        fdata.append("q9", answers["9"]);
        fdata.append("q10", answers["10"]);
        fdata.append("q11", answers["11"]);
        fdata.append("q12", answers["12"]);    
        
        var dataToSend = {};
        fdata.forEach(function (value, key) {
            dataToSend[key] = value;
        });
        var json = JSON.stringify(dataToSend);

        const requestMetadata = {
            headers: { 'Content-Type': 'application/json' },            
            method: 'POST',
            body: json
        };

        fetch('/api/v1/marketing/register', requestMetadata)
            .then(res => res.text())
            .then(results => {
                history.push(`/ThankYou`);
            });

        //END STATIC VERSION

        
        // fdata.append("fullname", state.fullname);
        // fdata.append("phone", state.phone);
        // fdata.append("email", state.email);
        // fdata.append("approvehidden", state.approvehidden);
        // fdata.append("q1", answers["1"]);
        // fdata.append("q2", answers["2"]);
        // fdata.append("q3", answers["3"]);
        // fdata.append("q4", answers["4"]);
        // fdata.append("q5", answers["5"]);
        // fdata.append("q6", answers["6"]);
        // fdata.append("q7", answers["7"]);
        // fdata.append("q8", answers["8"]);
        // fdata.append("q9", answers["9"]);
        // fdata.append("q10", answers["10"]);
        // fdata.append("q11", answers["11"]);
        // fdata.append("q12", answers["12"]);

        // const requestMetadata = {
        //     method: 'POST',
        //     body: fdata
        // };

        // fetch('https://www.onezerobank.com/QuizRegisterForm', requestMetadata)
        //     .then(res => res.text())
        //     .then(results => {
        //         history.push(`/ThankYou`);
        //     });
    }

    return (
        <>
            <div className="middle">
                <div className="res-middle res-form">
                    <img id="cloud1" className="cloud" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={cloud1} alt="" />
                    <img id="cloud2" className="cloud3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={cloud2} alt="" />
                    <img className="star rotate" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />
                    <img className="star2 rotate2" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />
                    <img className="star3 rotate3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />

                </div>
                <div className="question-container res-form">
                    <div className="resShareHold">
                        <img className="FormRresult" src={settings.isAnimationPause ? jpgResult : gifRresult} alt="" />
                    </div>
                    <div className="FormHeader">{translate('Glad You Came!')}</div>
                    <div className="secondHeader">
                        {translate('Simply enter the details below and voila,')}
                        <br/>
                        {translate('you’re on the waiting list for the new digital bank.')}
                    </div>
                    <div className="form">
                        <form onSubmit={formSubmitHandler}>
                            <div className="input-wrapper">
                                <input
                                    className="inp"
                                    type="text"
                                    name="fullname"
                                    placeholder={translate('Full Name')}
                                    value={state.fullname}
                                    onChange={handleChange}
                                    aria-label={translate('Enter full name (required)')}
                                    ref={nameInput}
                                />
                                <span className="input-error" id="error_fullname">{errors.fullname}</span>
                            </div>
                            <div className="input-wrapper">
                                <input
                                    className="inp"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    type="text"
                                    name="phone"
                                    placeholder={translate('Phone')}
                                    value={state.phone}
                                    onChange={handleChange}
                                    aria-label={translate('Enter phone number (required)')}
                                    ref={phoneInput}
                                    
                                />
                                <span className="input-error" id="error_phone">{errors.phone}</span>
                            </div>
                            <div className="input-wrapper">
                                <input
                                    className="inp"
                                    type="text"
                                    name="email"
                                    placeholder={translate('Email')}
                                    value={state.email}
                                    onChange={handleChange}
                                    aria-label={translate('Enter email address (required)')}
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                                    ref={emailInput}
                                />
                                <span className="input-error" id="error_email">{errors.email}</span>
                            </div>
                            <div className="note-wrapper">
                            <p>{translate('*Required fields')}</p>
                            </div>
                            <div className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="approvehidden"
                                    name="approvehidden"
                                    className="form-checkbox"
                                    onChange={handleCheckbox}
                                    defaultChecked={state.approvehidden}
                                    aria-checked={state.approvehidden}
                                    aria-labelledby="newsletterTerm"
                                />
                                <label id="newsletterTerm" htmlFor="approvehidden">{translate('Yes, I want to receive newsletters and promotional materials by email and SMS')}</label>
                            </div>
                            <div className="note-wrapper">
                                <p>{translate('The bank is under no obligation to open an account for those on the waiting list. For more details, please see our')} <a target="_blank" href="https://www.onezerobank.com/company/information/?ContentID=97">{translate('privacy policy.')}</a>.</p>
                                </div>
                            <button type="button" className="btnForm" type="submit">
                                <span>{translate('Submit')}</span>
                                <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                            </button>
                        </form>
                    </div>

                    
                    <div className="reslogo res-form">
                        <img width="150" src={getLogo()} alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}


export default Form

